// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__113G5","ranges":"BmiRanges_ranges__1nmMx"};